module.exports = __webpack_public_path__ + "static/media/corporateStep6.e5b0165a.svg";